interface ErrorProps {
  errorMessage: string;
}

export default function ErrorMessage(props: ErrorProps) {
  return (
    <div
      className="alert alert-danger"
      role="alert"
      dangerouslySetInnerHTML={{ __html: props.errorMessage }}
    ></div>
  );
}
